<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";

import {mapState, mapGetters} from "vuex";

import simplebar from "simplebar-vue";

import {with_acrf_token} from "@/methods";
import CopyableText from "../../../components/CopyableText.vue";
import {VclCode} from "vue-content-loading";
import {OrbitSpinner} from "epic-spinners";


export default {
  page: {
    title: "Application",
    meta: [{ name: "description", content: appConfig.description }]
  },
  computed: {

  },
  components: {
	  // eslint-disable-next-line vue/no-unused-components
	  VclCode,
    Layout,
  },
	methods: {
		handleError: function (error) {
			console.log(`[ERROR] ${error}`);
			this.error = true;
		},
		getData: function () {
			fetch(process.env.VUE_APP_ROOT_API + `v1/api/enterprise-api`, {credentials: 'include'})
			.then(response => {
				if (response.ok) {
					return response.json();
				} else {
					throw new Error(`(${this.$vnode.componentOptions.tag}) Failed with API error ${response.status}=${response.statusText} (${response.url})`);
				}
			})
			.then(data => {
				this.ready = true;
				this.chartData = data.charts;

				this.$nextTick(() => {
					this.$refs.requestCountChart.updateOptions({
						xaxis: {
							categories: this.chartData.requests.labels
						}
					})
					this.$refs.requestCountChart.updateSeries(this.chartData.requests.series);
				})
			})
			.catch(error => {
				this.handleError(error);
			});
		},
	},
  created() {

  },
	mounted() {
		this.getData();
		setInterval(() => {
			this.getData();
		}, 1000 * 60);
	},
	data() {
		return {
			ready: false,
			error: false,
			submitted: false,
			application: {
				name: null
			},
			chartData: null,
			showSecret: false,
			inProgress: false,
			saving: false,
			saved: false,
			deleting: false,
			charts: {
				requests: {
					series: [],
					chart: {
						noData: {
							text: 'Loading...'
						},
						chart: {
							height: 320,
							type: 'line',
							toolbar: 'false',
							dropShadow: {
								enabled: true,
								color: '#000',
								top: 18,
								left: 7,
								blur: 8,
								opacity: 0.2
							},
						},
						dataLabels: {
							enabled: false
						},
						colors: ['#f46a6a'],
						stroke: {
							curve: 'smooth',
							width: 3,
						},
						xaxis: {
							type: 'category',
							categories: []
						}
					}
				}
			}
		}
	}
};
</script>

<template>
  <Layout>
	  <div>
		  <template v-if="ready">
			  <template>
				  <div class="row mb-0 pb-0">
					  <div class="col">
						  <div class="card mini-stats-wid mb-0 pb-0">
							  <div class="card-body" style="height: 6rem;">
								  <div class="d-flex flex-wrap">
									  <div class="me-3">
										  <h6 class="text-muted mb-2 text-uppercase">
											  Request Count (Year)
										  </h6>
										  <h5 class="mb-0">
											  {{ $n(this.chartData.requests.year) }}
										  </h5>
									  </div>
								  </div>
							  </div>
						  </div>
					  </div>
					  <div class="col">
						  <div class="card mini-stats-wid mb-0 pb-0">
							  <div class="card-body" style="height: 6rem;">
								  <div class="d-flex flex-fill w-100">
									  <div class="me-3 w-100">
										  <h6 class="text-muted mb-2 text-uppercase">
										    Request Count (Month)
										  </h6>
										  <h5 class="mb-0">
											  {{ $n(this.chartData.requests.month) }}
										  </h5>
									  </div>
								  </div>
							  </div>
						  </div>
					  </div>
				  </div>
				  <div class="row mt-4">
					  <div class="col-lg-12 col-sm-12">
						  <div class="card card-body">
							  <h6 class="text-muted mb-2 text-uppercase">
								  Request Statistics
								  <template v-if="(new Date().getFullYear() === 2023) || (new Date().getFullYear() <= 2024 && new Date().getMonth() <= 8)">
									<span class="badge badge-info text-black font-weight-bolder">
										Statistics collection since 08.2023
									</span>
								  </template>
							  </h6>

							  <div class="mr-4">
								  <apexchart
										  ref="requestCountChart"
										  class="apex-charts"
										  dir="ltr"
										  height="320"
										  :series="charts.requests.series"
										  :options="charts.requests.chart"
								  ></apexchart>
							  </div>
						  </div>
					  </div>
				  </div>
			  </template>
		  </template>
		  <template v-else-if="error">
			  <div class="row">
				  <div class="col-lg-12 col-sm-12 row justify-content-center">
					  <div class="col-lg-6 col-sm-12">
						  <div class="card border border-danger">
							  <div class="card-header bg-transparent border-danger">
								  <h5 class="my-0 text-danger">
									  <i class="far fa-exclamation-circle mr-3"></i>
									  We have encountered an error
								  </h5>
							  </div>
							  <div class="card-body pt-0">
								  <h5 class="card-title mt-0">Please try again later</h5>
							  </div>
						  </div>
					  </div>
				  </div>
			  </div>
		  </template>
		  <template v-else>
			  <div class="row">
				  <div class="col-lg-3 col-sm-12" v-for="index in 4" :key="index">
					  <div class="card">
						  <div class="card-body">
							  <vcl-code :width="300" :speed="1" primary="#FFFFFF" secondary="#bdbdbd"></vcl-code>
						  </div>
					  </div>
				  </div>
			  </div>
		  </template>
	  </div>
  </Layout>
</template>